/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { generatePath, useHistory } from "react-router-dom";
import { useCallback } from "react";

export const useGenerateTemplatedUrl: () => typeof generatePath = () => {
  const history = useHistory();
  return useCallback(
    (...args: Parameters<typeof generatePath>) => {
      const relativeUrl = history.createHref({
        pathname: generatePath(...args),
      });
      return `${process.env.CDN_ROOT}${relativeUrl}`;
    },
    [history]
  );
};

export const useTemplatedUrl: typeof generatePath = (...args): string => {
  return useGenerateTemplatedUrl()(...args);
};
